
export const rootPath = ( window.location.href.indexOf("localhost") > -1  ? "http://localhost:1245" : "");
export const mySessKey = "g1lM0re";